import * as types from './CustomersTypes';

export default function CustomersReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_CUSTOMERS:
            return {
                ...state,
                getCustomers: {
                    ...state.getCustomers,
                    customers: payload.data,
                    firstCustomer: payload.first,
                    lastCustomer: payload.last,
                    nextCustomers: payload.next,
                    customersFilter: [],
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_CUSTOMERS_LOADING:
            return {
                ...state,
                getCustomers: {
                    ...state.getCustomers,
                    loading: true
                },
            };
        case types.GET_CUSTOMERS_ERROR:
            return {
                ...state,
                getCustomers: {
                    ...state.getCustomers,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_CUSTOMERS_ALL_MONTH:
            return {
                ...state,
                getCustomersAllMonth: {
                    ...state.getCustomersAllMonth,
                    customers: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CUSTOMERS_ALL_MONTH_LOADING:
            return {
                ...state,
                getCustomersAllMonth: {
                    ...state.getCustomersAllMonth,
                    loading: true
                },
            };
        case types.GET_CUSTOMERS_ALL_MONTH_ERROR:
            return {
                ...state,
                getCustomersAllMonth: {
                    ...state.getCustomersAllMonth,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CUSTOMERS_BY_ID:
            return {
                ...state,
                getCustomersById: {
                    ...state.getCustomersById,
                    customer: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_CUSTOMERS_FILTER:
            return {
                ...state,
                getCustomers: {
                    ...state.getCustomers,
                    customersFilter: payload.data,
                    firstCustomer: payload.first,
                    lastCustomer: payload.last,
                    nextCustomers: payload.next,
                    loading: false
                },
            };
        case types.GET_CUSTOMERS_FILTER_LOADING:
            return {
                ...state,
                getCustomers: {
                    ...state.getCustomers,
                    loading: true
                },
            };
        case types.GET_CUSTOMERS_FILTER_ERROR:
            return {
                ...state,
                getCustomers: {
                    ...state.getCustomers,
                    promotionsFilter: [],
                    loading: false
                },
            };
        case types.GET_CUSTOMERS_EXCEL:
            return {
                ...state,
                getCustomersExcel: {
                    ...state.getCustomersExcel,
                    customers: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_CUSTOMERS_EXCEL_LOADING:
            return {
                ...state,
                getCustomersExcel: {
                    ...state.getCustomersExcel,
                    loading: true
                },
            };
        case types.GET_CUSTOMERS_EXCEL_ERROR:
            return {
                ...state,
                getCustomersExcel: {
                    ...state.getCustomersExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CUSTOMERS_FILTER_EXCEL:
            return {
                ...state,
                getCustomersExcel: {
                    ...state.getCustomersExcel,
                    customersFilter: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_CUSTOMERS_FILTER_EXCEL_LOADING:
            return {
                ...state,
                getCustomersExcel: {
                    ...state.getCustomersExcel,
                    loading: true
                },
            };
        case types.GET_CUSTOMERS_FILTER_EXCEL_ERROR:
            return {
                ...state,
                getCustomersExcel: {
                    ...state.getCustomersExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CUSTOMERS_EXCEL_RESET_STATE:
            return {
                ...state,
                getCustomersExcel: {
                    ...state.getCustomersExcel,
                    customers: [],
                    customersFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CUSTOMERS_BY_ID_LOADING:
            return {
                ...state,
                getCustomersById: {
                    ...state.getCustomersById,
                    loading: true
                },
            };
        case types.GET_CUSTOMERS_BY_ID_ERROR:
            return {
                ...state,
                getCustomersById: {
                    ...state.getCustomersById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.CREATE_CUSTOMERS:
            return {
                ...state,
                createCustomers: {
                    ...state.createCustomers,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.CREATE_CUSTOMERS_LOADING:
            return {
                ...state,
                createCustomers: {
                    ...state.createCustomers,
                    loading: true
                },
            };
        case types.CREATE_CUSTOMERS_ERROR:
            return {
                ...state,
                createCustomers: {
                    ...state.createCustomers,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.CREATE_CUSTOMERS_RESET_STATE:
            return {
                ...state,
                createCustomers: {
                    ...state.createCustomers,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CUSTOMERS_RESET_STATE:
            return {
                ...state,
                getCustomers: {
                    customers: [],
                    firstCustomer: null,
                    lastCustomer: null,
                    nextCustomers: null,
                    customersFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getCustomersById: {
                    customer: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getCustomersExcel: {
                    customers: [],
                    customersFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                }
            };
    
        default:
            return state;
    }
}